import { render, staticRenderFns } from "./BiddersTable.vue?vue&type=template&id=8f664320&scoped=true"
import script from "./BiddersTable.vue?vue&type=script&lang=js"
export * from "./BiddersTable.vue?vue&type=script&lang=js"
import style0 from "./BiddersTable.vue?vue&type=style&index=0&id=8f664320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f664320",
  null
  
)

export default component.exports